import API from '../../apiCreate'
import type {
  IntegrationLogIndexParams,
  ResponseIntegrationLogCatalog,
  ResponseIntegrationLogIndex,
} from './integration-log.types'

const appendParam = (
  parts: string[],
  key: string,
  value: string | number | null | undefined,
) => {
  if (value == null) return
  const text = String(value).trim()
  if (!text) return
  parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(text)}`)
}

/** Query для index: event[] и числовые id без getParams (там массивы ломаются). */
export const buildIntegrationLogIndexQuery = (
  params: IntegrationLogIndexParams = {},
): string => {
  const parts: string[] = []

  appendParam(parts, 'direction', params.direction)
  appendParam(parts, 'category', params.category)
  appendParam(parts, 'source', params.source)
  appendParam(parts, 'status', params.status)
  appendParam(parts, 'connection_type', params.connection_type)
  appendParam(parts, 'connection_id', params.connection_id)
  appendParam(parts, 'entity_type', params.entity_type)
  appendParam(parts, 'entity_id', params.entity_id)
  appendParam(parts, 'date_from', params.date_from)
  appendParam(parts, 'date_to', params.date_to)
  appendParam(parts, 'query', params.query)
  appendParam(parts, 'page', params.page)
  appendParam(parts, 'per-page', params['per-page'])

  const events = Array.isArray(params.event)
    ? params.event
    : params.event
      ? [params.event]
      : []
  const uniqueEvents = Array.from(
    new Set(events.map((item) => String(item).trim()).filter(Boolean)),
  ).slice(0, 50)
  if (uniqueEvents.length === 1) {
    appendParam(parts, 'event', uniqueEvents[0])
  } else {
    uniqueEvents.forEach((event) => appendParam(parts, 'event[]', event))
  }

  return parts.length ? `?${parts.join('&')}` : ''
}

export const integrationLogApi = {
  /** GET /v1/integration-log/catalog */
  getCatalog: () =>
    API.get<ResponseIntegrationLogCatalog>('integration-log/catalog'),

  /** GET /v1/integration-log/index */
  getIndex: (params: IntegrationLogIndexParams = {}) =>
    API.get<ResponseIntegrationLogIndex>(
      `integration-log/index${buildIntegrationLogIndexQuery(params)}`,
    ),

  /** Alias для legacy ExternalAPISettings */
  list: (params: IntegrationLogIndexParams = {}) =>
    API.get<ResponseIntegrationLogIndex>(
      `integration-log/index${buildIntegrationLogIndexQuery(params)}`,
    ),
}
